import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';
import { MessageType } from '@gig/magic-sdk/dist/adapter/messages/message';
import { isHidden } from '../../util/messages.js';
import '../../util/dom.js';
import { MESSAGING_LOADED, MESSAGING_LIST } from '@gig/magic-messages';

var MessagesComponent = /** @class */ (function (_super) {
    __extends(MessagesComponent, _super);
    function MessagesComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * List of all the messages
         */
        _this.messages = [];
        /**
         * Messages loading state
         */
        _this.isLoading = false;
        _this.allowedTypes = [
            MessageType.NOTIFICATION,
            MessageType.AD_HOC,
            MessageType.CAMPAIGN,
            MessageType.PLAY_SAFE,
        ];
        return _this;
    }
    MessagesComponent.prototype.created = function () {
        var _this = this;
        this.messageSubscription = window.eventBus.subscribe(MESSAGING_LOADED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = !event.payload;
                        if (this.isLoading) {
                            this.messages = [];
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(MESSAGING_LIST)];
                    case 1:
                        _a.messages = _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    MessagesComponent.prototype.destroyed = function () {
        var _a;
        (_a = this.messageSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    Object.defineProperty(MessagesComponent.prototype, "message", {
        get: function () {
            var _this = this;
            return this.messages.find(function (_a) {
                var id = _a.id;
                return id === _this.messageId;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MessagesComponent.prototype, "filteredMessages", {
        get: function () {
            var _this = this;
            return this.messages.filter(function (message) {
                return _this.allowedTypes.includes(message.type) && !isHidden(message);
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], MessagesComponent.prototype, "messageId", void 0);
    MessagesComponent = __decorate([
        Component({
            name: 'messages',
        })
    ], MessagesComponent);
    return MessagesComponent;
}(Mixins(MagicConfigMixin)));

export default MessagesComponent;
